import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import i18next from 'i18next'

import * as wopiQuestionnaireActions from '../../ducks/wopi-questionnaire'

import WopiQuestionnaire from '../WopiQuestionnaire'
import Loading from '../Loading'
import App from '../App'
import withPreventNavigation from '../hocs/withPreventNavigation'

class WopiQuestionnaireContainer extends Component {
  componentDidMount() {
    const { resetQuestionnaire, fetchQuestionnaire } = this.props

    resetQuestionnaire()
    fetchQuestionnaire(this.props.routeParams.uuid)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language !== this.props.language) {
      this.props.fetchTranslationsForQuestions(nextProps.language)
    }
  }

  render() {
    const {
      isLoading,
      questions,
      language,
      isTranslationReady,
      fetchTranslationsForQuestions,
      routeParams,

      isStarted,
      personalInformation,
      activeQuestionIndex,
      activeQuestionAnswer,
      activeSetupPhase,
      startQuestionnaire,
      answerWopiQuestion,
      goToNextPhase,
      submitPersonalAndStatisticalInformation
    } = this.props

    const renderPhase = () => {
      if (!isLoading && questions.isEmpty()) {
        return (
          <div style={{ textAlign: 'center' }}>
            <h1>{i18next.t('questionnaire_not_found', { lng: language, ns: 'questionnaire' })}</h1>
          </div>
        )
      }

      return (
        <WopiQuestionnaire
          uuid={routeParams.uuid}
          isStarted={isStarted}
          questions={questions}
          personalInformation={personalInformation}
          activeQuestionIndex={activeQuestionIndex}
          activeQuestionAnswer={activeQuestionAnswer}
          activeSetupPhase={activeSetupPhase}
          language={language}
          startQuestionnaire={startQuestionnaire}
          answerWopiQuestion={answerWopiQuestion}
          goToNextPhase={goToNextPhase}
          submitPersonalAndStatisticalInformation={submitPersonalAndStatisticalInformation}
          refreshQuestionnaire={() => this.props.fetchQuestionnaire(this.props.routeParams.uuid)}
        />
      )
    }

    return (
      <App
        currentLanguage={language}
        hideNonAdminLanguages={false}
        hideLanguageSwitcher={isStarted}
        onChangeLanguage={language => fetchTranslationsForQuestions(language)}
      >
        <Loading isReady={!isLoading && isTranslationReady}>{renderPhase()}</Loading>
      </App>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.wopiQuestionnaire.get('isLoading'),
    questions: state.wopiQuestionnaire.get('questions'),
    isTranslationReady: state.wopiQuestionnaire.get('isTranslationReady'),
    language: state.wopiQuestionnaire.get('language'),

    isStarted: state.wopiQuestionnaire.get('isStarted'),
    questions: state.wopiQuestionnaire.get('questions'),
    personalInformation: state.wopiQuestionnaire.get('personalInformation'),
    activeQuestionIndex: state.wopiQuestionnaire.get('activeQuestionIndex'),
    activeQuestionAnswer: state.wopiQuestionnaire.get('activeQuestionAnswer'),
    activeSetupPhase: state.wopiQuestionnaire.get('activeSetupPhase'),
    language: state.wopiQuestionnaire.get('language'),
    isFinished: state.wopiQuestionnaire.get('isFinished')
  }
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(wopiQuestionnaireActions, dispatch)

  return {
    resetQuestionnaire: actions.resetQuestionnaire,
    fetchQuestionnaire: actions.fetchQuestionnaire,
    fetchTranslationsForQuestions: actions.fetchTranslationsForQuestions,

    answerWopiQuestion: actions.answerWopiQuestion,
    startQuestionnaire: actions.startQuestionnaire,
    goToNextPhase: actions.goToNextPhase,
    submitPersonalAndStatisticalInformation: actions.submitPersonalAndStatisticalInformation
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withPreventNavigation(WopiQuestionnaireContainer)
)



// WEBPACK FOOTER //
// ./src/components/smart/WopiQuestionnaireContainer.js